<template>
  <div class="kiw-single">
    <app-view-layout :header="kiw.name">
      <template #toolbarMenu>
        <v-btn
          v-if="actions.length"
          class="mr-2"
          depressed
          color="primary"
          @click="makeAction"
        >
          Podejmij działanie
        </v-btn>

        <v-btn
          v-if="kiw.editable"
          class="mr-2"
          depressed
          color="primary"
          :to="{ name: 'kiw-edit', id: kiw.id }"
        >
          Zapisz
        </v-btn>

        <v-btn
          v-if="kiw.editable"
          class="mr-2"
          depressed
          color="primary"
          @click="confirmKIWDelete"
        >
          Usuń
        </v-btn>
      </template>

      <template #content>
        <div>
          <KIWFormCard
            :value="kiw"
            disabled
            class="mt-4 mb-8"
          />

          <TemplateSelected
            v-if="kiw.project && kiw.project.id"
            :id="kiw.project.id"
            type="Project"
          />

          <app-text-card
            :value="kiw.notes || ''"
            class="mb-8"
            title="Komentarz"
            disabled
          >
            <AppEmptyState
              title="Brak komentarza"
              subtitle="Oczekiwanie na dodanie komentarza."
              class="pb-16"
            />
          </app-text-card>

          <ProjectFilesCard
            :disable-addition="!filesActionsPermitted"
            hide-tabs
            kiw-files
            :disable-delete="!filesActionsPermitted"
            :files="kiw.files"
            :processing="isProcessing"
            class="mb-8"
            @add="showFileAddDialog"
            @delete="destroyKIWFiles"
          />

          <app-text-card
            :value="kiw.guardNotes"
            class="mb-8"
            title="Komentarz strażnika KIW"
            disabled
          >
            <AppEmptyState
              title="Brak komentarza strażnika KIW"
              subtitle="Wniosek nie został skomentowany przez strażnika KIW"
              class="pb-16"
            />
          </app-text-card>
        </div>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import KIWFormCard from '@/components/KIW/KIWFormCard.vue';
import TemplateSelected from '@/components/Projects/TemplateSelected.vue';
import AppTextCard from '@/components/UI/AppTextCard.vue';
import ProjectFilesCard from '@/components/Projects/ProjectFilesCard.vue';
import AppEmptyState from '@/components/UI/AppEmptyState.vue';

export default {
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },

  components: {
    AppViewLayout,
    KIWFormCard,
    TemplateSelected,
    AppTextCard,
    ProjectFilesCard,
    AppEmptyState,
  },

  computed: {
    ...mapState('kiwSingle', [
      'kiw',
      'isProcessing',
      'actions',
    ]),

    ...mapGetters('auth', [
      'checkUserPermissions',
    ]),

    filesActionsPermitted() {
      const availability = ['admin_director', 'chief', 'guard'];
      return this.kiw.editable || this.checkUserPermissions(availability);
    },
  },

  created() {
    this.fetchSingleKIW(this.id)
      .then(() => {
        this.fetchKIWActions(this.id);
      });
  },

  beforeDestroy() {
    this.resetSingleKIW();
  },

  methods: {
    ...mapActions('kiwSingle', [
      'fetchSingleKIW',
      'resetSingleKIW',
      'fetchKIWActions',
      'destroyKIWFiles',
      'deleteSingleKIW',
    ]),
    ...mapActions('dialog', [
      'showDialog',
    ]),

    showFileAddDialog() {
      this.showDialog({
        header: 'Dodawanie pliku/ów',
        text: 'Wybierz plik/i i dodaj do wniosku KIW.',
        component: 'FileUpload',
        props: {
          kiwFile: true,
        },
      });
    },

    makeAction() {
      this.showDialog({
        header: 'Potwierdzenie działania',
        text: 'Masz do podjęcia działania w projekcie.',
        component: 'MakeAction',
        props: {
          id: this.id,
          actions: this.actions,
          kiw: true,
          width:640
        },
      });
    },

    confirmKIWDelete() {
      this.showDialog({
        header: 'Usuwanie Wniosku',
        text: '<b>Czy na pewno chcesz usunąć ten wniosek?</b> <br/> Nie będzie można cofnąć tej akcji.',
        component: 'Confirm',
        props: {
          confirmText: 'Usuń',
          rejectText: 'Nie usuwaj',
        },
      })
        .then(() => {
          this.deleteSingleKIW(this.id);
        })
        .catch(() => {
          this.clearDialog();
        });
    },
  },
};
</script>
